/* Emir ICE — bandeau d'annonce de l'ordinateur : plusieurs messages, un seul visible à la fois (refonte, 2026-10-14)
   Le texte du réglage « Announcement bar » peut contenir plusieurs messages séparés par « · » (hors des balises : un « · » écrit DANS un <strong>,
   comme « EXPÉDITION 24–48H · LIVRAISON 2 À 5 JOURS », reste dans son message). Les liens et le gras sont conservés tels quels.
   - 1 seul message : rien ne change ; sinon rotation toutes les 6 s, mise en pause au survol et au focus, boutons précédent / suivant (clavier),
     compteur « 1/2 », hauteur fixe (aucun saut de mise en page), bouton de fermeture du thème conservé.
   - prefers-reduced-motion : pas de rotation automatique ni d'animation ; on passe d'un message à l'autre avec les boutons.
   - Mobile (≤ 798 px) : on ne touche à rien, le thème (emir-mobile-header.liquid) fait défiler le texte complet.
   InstantClick : init() rejouée à chaque page, écouteurs globaux posés une seule fois. */
(function () {
  'use strict';
  if (window.__eixTop) { window.__eixTop.init(); return; }

  var doc = document;
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 799px)') : { matches: true };
  var mqRed = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var S = { timer: 0, i: 0, n: 0, pause: false, box: null, orig: null };
  var CHEV_L = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M7.5 2 3.5 6l4 4"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M4.500 2 8.500 6l-4 4"/></svg>';

  /* découpe la ligne d'annonce aux « · » situés entre les balises, pas dans une balise */
  function split(p) {
    var msgs = [[]];
    Array.prototype.forEach.call(p.childNodes, function (nd) {
      if (nd.nodeType === 3) {
        var parts = nd.nodeValue.split(/\s*[·•]\s*/);
        parts.forEach(function (t, k) {
          if (k > 0) msgs.push([]);
          if (t) msgs[msgs.length - 1].push(doc.createTextNode(t));
        });
      } else { msgs[msgs.length - 1].push(nd.cloneNode(true)); }
    });
    return msgs.filter(function (m) { return m.some(function (nd) { return (nd.textContent || '').trim(); }); });
  }

  function show(k, user) {
    if (!S.box) return;
    var items = S.box.querySelectorAll('.eix-an__m');
    S.i = (k + items.length) % items.length;
    Array.prototype.forEach.call(items, function (m, j) {
      var on = j === S.i;
      m.classList.toggle('is-on', on);
      m.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (m.inert !== undefined) m.inert = !on;
    });
    var n = S.box.querySelector('.eix-an__n'); if (n) n.textContent = (S.i + 1) + '/' + items.length;
    if (user) restart();
  }

  function tick() { if (!S.pause && !mqRed.matches && !doc.hidden) show(S.i + 1, false); }
  function restart() { clearInterval(S.timer); if (!mqRed.matches && S.n > 1) S.timer = setInterval(tick, 6000); }

  function build() {
    var bar = doc.querySelector('.header .promo_banner');
    var box = bar && bar.querySelector('.promo_banner__content');
    if (!box || box.querySelector('.eix-an') || !mqDesk.matches) return;
    var p = box.querySelector('p') || box;
    var msgs = split(p);
    S.orig = box.innerHTML;
    if (msgs.length < 2) return;
    var wrap = doc.createElement('div');
    wrap.className = 'eix-an';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-roledescription', 'carrousel');
    wrap.setAttribute('aria-label', 'Annonces');
    var vp = doc.createElement('div'); vp.className = 'eix-an__vp';
    msgs.forEach(function (nodes, k) {
      var m = doc.createElement('div'); m.className = 'eix-an__m';
      m.setAttribute('role', 'group'); m.setAttribute('aria-label', (k + 1) + ' sur ' + msgs.length);
      var sp = doc.createElement('span');
      nodes.forEach(function (nd) { sp.appendChild(nd); });
      m.appendChild(sp); vp.appendChild(m);
    });
    var ctl = doc.createElement('div'); ctl.className = 'eix-an__ctl';
    ctl.innerHTML = '<button type="button" class="eix-an__b" data-eix-an="prev" aria-label="Annonce précédente">' + CHEV_L + '</button>' +
      '<span class="eix-an__n" aria-hidden="true"></span>' +
      '<button type="button" class="eix-an__b" data-eix-an="next" aria-label="Annonce suivante">' + CHEV_R + '</button>';
    wrap.appendChild(vp); wrap.appendChild(ctl);
    box.innerHTML = ''; box.appendChild(wrap);
    S.box = wrap; S.n = msgs.length; S.pause = false;
    wrap.setAttribute('aria-live', 'off');
    show(0, false);
    restart();
  }

  function teardown() {
    clearInterval(S.timer);
    var bar = doc.querySelector('.header .promo_banner .promo_banner__content');
    if (S.box && bar && S.orig != null && bar.contains(S.box)) bar.innerHTML = S.orig;
    S.box = null; S.n = 0;
  }

  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-eix-an]') : null;
    if (!b) return;
    e.preventDefault();
    var live = S.box; if (live) live.setAttribute('aria-live', 'polite');
    show(S.i + (b.getAttribute('data-eix-an') === 'next' ? 1 : -1), true);
  }, false);
  function inBar(t) { return !!(t && t.closest && t.closest('.eix-an')); }
  doc.addEventListener('pointerover', function (e) { if (inBar(e.target)) S.pause = true; }, true);
  doc.addEventListener('pointerout', function (e) { if (inBar(e.target) && !inBar(e.relatedTarget)) S.pause = false; }, true);
  doc.addEventListener('focusin', function (e) { if (inBar(e.target)) S.pause = true; }, true);
  doc.addEventListener('focusout', function (e) { if (inBar(e.target) && !inBar(e.relatedTarget)) S.pause = false; }, true);
  doc.addEventListener('keydown', function (e) {
    if (!inBar(e.target)) return;
    if (e.key === 'ArrowRight') { show(S.i + 1, true); }
    else if (e.key === 'ArrowLeft') { show(S.i - 1, true); }
  }, false);

  function init() {
    clearInterval(S.timer); S.box = null; S.n = 0;
    build();
  }
  if (mqDesk.addEventListener) mqDesk.addEventListener('change', function () { if (mqDesk.matches) init(); else teardown(); });
  if (mqRed.addEventListener) mqRed.addEventListener('change', restart);

  window.__eixTop = { init: init };
  function boot() {
    init();
    doc.addEventListener('instantclick:newpage', init);
    if (window.InstantClick && typeof window.InstantClick.on === 'function') { try { window.InstantClick.on('change', init); } catch (e) {} }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
